const setCookie = (name, value, expire, domain) => {
    let date = new Date()
    date.setSeconds(date.getSeconds() + expire)
    let str = domain ? ';domain=' + domain + ';path=/' : null
    document.cookie = name + ' = ' + escape(value) + '; expires=' + date.toGMTString() + str
}

const getCookie = (name) => {
    let arr = []
    let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    arr = document.cookie.match(reg) || []
    return arr.length > 2 ? unescape(arr[2]) : null
}

const delCookie = (name) => {
    let exp = new Date()
    exp.setTime(exp.getTime() - 1)
    let cval = getCookie(name)
    if (cval != null) {
        document.cookie = name + ' = ' + cval + '; expires=' + exp.toGMTString()
    }
}

export {
    setCookie,
    getCookie,
    delCookie,
}
